export default "__VITE_ASSET__2ee2be2e__"